<template>
  <el-form-item v-bind="itemBinds" class="master-table" label-width="0">
    <!-- header -->
    <div class="master-table-header">
      <FormHeader>{{ $t('performanceAppraisal.performanceAppraisal.formTitle.processDetail') }}</FormHeader>
      <!-- <JurisdictionBtn v-if="!disabled" icon="icon-daoru" @click="importDetail">
        {{ $t('performanceAppraisal.performanceAppraisal.import') }}
      </JurisdictionBtn> -->
    </div>
    <template v-if="tableData.length > 0">
      <div class="main-content">
        <div v-if="!noLeft" class="left-content">
          <el-scrollbar ref="scrollbar" style="height: 100%; width: 100%;">
            <div
              v-for="(item, index) of groupNameList"
              :key="index"
              class="material-item"
              :class="{'material-item-active':item.groupNo === activeGroup.groupNo}"
              @click="changeGroup(item)"
            >
              <div class="material-item-label">
                {{ item.groupName }}
              </div>
              <div class="material-item-no">
                {{ item.groupNo }}
              </div>
            </div>
          </el-scrollbar>
        </div>
        <div class="right-content">
          <el-table
            :data="tableData"
            :style="tableWidth"
            max-height="325px"
            :header-row-style="styleFunc"
            :cell-style="columnStyle"
          >
            <template>
              <el-table-column v-for="item in originColumn" :key="item.origin" fixed="left" :label="item.tabName" :width="originWidth">
                <template v-for="itemNew in item.columns">
                  <el-table-column
                    v-if="itemNew.isView"
                    :key="itemNew.prop"
                    :prop="itemNew.prop"
                    :label="itemNew.quotaName"
                    :width="itemNew.width"
                  >
                    <template v-slot="{ row, column }">
                      <span style="font-weight: 600;">{{ row[column.property] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table-column>
            </template>
            <template v-for="(item, index) in columns">
              <el-table-column :key="index" :label="item.tabName">
                <el-table-column
                  v-for="(itemNew, number) in item.columns"
                  :key="number"
                  width="200"
                  :prop="itemNew.quotaName"
                  :label="itemNew.quotaNameConcat"
                >
                  <template v-slot="{ row, column }">
                    <span v-if="disabled">{{ row[column.property] }}</span>
                    <template v-else>
                      <el-input-number
                        v-model="row[column.property]"
                        style="width: 150px;margin-right: 7px;"
                        controls-position="right"
                      />
                      <i
                        class="iconfont icon-cankaoshuju"
                        style="cursor: pointer;color:#2D71FB;"
                        @click="iconHandle(row, column.property)"
                      />
                    </template>
                  </template>
                </el-table-column>
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
      <!--      <div class="examine-table-footer">-->
      <!--        <el-pagination-->
      <!--          background-->
      <!--          hide-on-single-page-->
      <!--          layout="total, sizes, prev, pager, next, jumper"-->
      <!--          :current-page="page"-->
      <!--          :page-size="limit"-->
      <!--          :page-sizes="[10, 20, 30, 50]"-->
      <!--          :total="total"-->
      <!--          @current-change="currentChange"-->
      <!--          @size-change="sizeChange"-->
      <!--        />-->
      <!--      </div>-->
    </template>
    <template v-else>
      <Empty />
    </template>
  </el-form-item>
</template>

<script>
import FormHeader from '@/components/form/form-header/form-header.vue'
// import JurisdictionBtn from '@/components/common/jurisdiction-btn/jurisdiction-btn.vue'
import Empty from './small/empty.vue'
import { dialogImport } from '@/utils'

export default {
  name: 'NoEvaluationSysTable',
  components: {
    FormHeader,
    // JurisdictionBtn,
    Empty
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    },
    itemBinds: {
      type: Object,
      default: () => ({})
    },
    isMark: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      originColumn: [{
        tabName: this.$t('performanceAppraisal.analysisPlatform.rateInfo'), origin: 'origin', columns: [
          { quotaName: '#', data: '', prop: 'index', isView: true, width: '50' },
          {
            quotaName: this.$t('performanceAppraisal.analysisPlatform.supplier'),
            width: '200',
            data: '',
            prop: 'supplierName',
            isView: true
          },
          {
            quotaName: this.$t('performanceAppraisal.analysisPlatform.score'),
            width: '100',
            data: '',
            prop: 'sumMark',
            isView: this.isView
          },
          {
            quotaName: this.$t('performanceAppraisal.analysisPlatform.level'),
            width: '100',
            data: '',
            prop: 'supplierLevel',
            isView: this.isView
          },
          {
            quotaName: this.$t('performanceAppraisal.analysisPlatform.supBatLevel'),
            width: '150',
            data: '',
            prop: 'supBatLevel',
            isView: this.isView
          }
        ]
      }
      ],
      tableData: [],
      columns: [],
      indexArr: [],
      visible: false,
      groupNameList: [],
      page: 1,
      limit: 10,
      eleCount: [],
      tabNameMap: [],
      firstTableArray: [],
      tableArray: [],
      allData: [],
      activeGroup: {},
      downloadParam: '',
      tableWidth: {},
      noLeft: false
    }
  },
  computed: {
    total() {
      return this.examListCopy?.length || 0
    },
    originWidth() {
      return this.isView ? '600' : '250'
    },
    assessSystemNo() {
      return this.isMark ? this.data.markBase.assessSystemNo : this.data.assessSystemNo
    },
    purchaseUnitNo() {
      return this.isMark ? this.data.markBase.purchaseUnitNo : this.data.purchaseUnit
    },
    downloadName() {
      return this.isMark
        ? this.$t('performanceAppraisal.performanceAppraisal.downloadName[1]')
        : this.$t('performanceAppraisal.performanceAppraisal.downloadName[0]')
    }
  },
  created() {
    // 点击列表页绩效单号查看
    if (this.disabled) {
      this.init(this.value)
    }
    // 有评估体系评分
    if (this.isMark) {
      this.init(this.value)
      this.downloadParam = `processNo=${this.data.markBase.processNo}&purchaseUnitNo=${this.data.markBase.purchaseUnitNo}&judgeType=${this.data.markBase.judgeType}&assessSystemNo=${this.assessSystemNo}`
    } else {
      this.downloadParam = `assessSystemNo=${this.assessSystemNo}&processNo=&judgeType=&purchaseUnitNo=`
    }
  },
  methods: {
    async importDetail() {
      if (!this.isMark && !this.data.purchaseUnit) {
        this.$message.warning(this.$t('performanceAppraisal.performanceAppraisal.importWarn'))
        return
      }
      const data = await dialogImport({
        url: '/examineProcess/importProcessExcel',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: {
          assessSystemNo: this.assessSystemNo,
          purchaseUnitNo: this.purchaseUnitNo,
          processNo: this.assessSystemNo === '0000' ? '' : this.data.markBase.processNo
        },
        downloadUrl: '/examineProcess/downloadProcessTemplate?' + this.downloadParam,
        downloadBaseURL: process.env.VUE_APP_PURCHASE_API,
        downloadName: this.downloadName
      })
      this.init(data)
    },
    init(data) {
      this.allData = data
      // 左侧物料列表
      this.groupNameList = data['groupModel']
      if (this.groupNameList.length > 0) {
        this.activeGroup = this.groupNameList[0]
      } else {
        this.noLeft = true
      }
      this.getTableData(data['groupData'][0])
      this.$emit('input', this.allData)
      // if (!this.isMark) {
      //   this.$emit('input', this.allData)
      // }
    },
    getTableData(oneGroupData) {
      if (this.columns.length === 0) {
        this.columns.push(...oneGroupData['tabHeadInfo'] || [])
      }
      this.tableData = oneGroupData.tabData || []
      // 按照number字段排序
      this.columns = this.columns.sort(this.sortsFun('number'))
      this.columns.map((item) => {
        item.columns = item.columns.sort(this.sortsFun('number'))
      })
      // 计算分开
      let number = 0
      const column = this.originColumn.concat(this.columns)
      this.indexArr = []
      column.map((item) => {
        this.indexArr.push(item.columns.length + number - 1)
        number += item.columns.length
      })
      this.tableWidth = { width: ((number * 231) + 250) + 'px' }
    },
    currentChange(val) {
      this.page = val
    },
    sizeChange(val) {
      this.limit = val
    },
    changeGroup(item) {
      this.activeGroup = item
      const groupData = this.allData['groupData']
      const param = groupData.filter(item => {
        return item.groupNo === this.activeGroup.groupNo
      })
      if (param.length > 0) {
        this.getTableData(param[0])
      }
    },
    iconHandle(row, props) {
      this.$message.info(this.$t('common.comingSoon') || '')
      console.log(row, props)
    },
    styleFunc(row) {
      if (row.rowIndex === 0) {
        return 'color: #333; fontSize: 14px; font-weight: 500;margin: 0 2px;'
      }
      if (row.rowIndex === 1) {
        return 'color: #333; fontSize: 13px; font-weight: 400;'
      }
    },
    columnStyle({ columnIndex }) {
      if (this.indexArr.includes(columnIndex)) {
        return 'border-right: 2px solid #EBEEF5'
      }
    },
    sortsFun(arr) {
      return function(a, b) {
        const v1 = a[arr]
        const v2 = b[arr]
        return v1 - v2
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.master-table-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.main-content {
  max-height: 380px;
  width: 100%;
  display: flex;

  .left-content {
    width: 142px;
    margin-right: 9px;

    .material-item {
      width: 100%;
      height: 70px;
      cursor: pointer;
      font-family: PingFangHK-Medium, serif;
      font-weight: 500;
      font-size: 13px;
      padding: 12px;
      border: 1px solid #F6F7F8;
      border-bottom: none;
      box-sizing: border-box;
      color: #666666;

      &:nth-last-of-type(1) {
        border-bottom: 1px solid #F6F7F8;
      }

      .material-item-label {
        height: 21px;
        color: #333333;
      }
      .material-item-no {
        font-size: 12px;
      }

      &:hover {
        color: #fff;
        background: #2D71FB;
        .material-item-label {
          color: #fff;
        }
      }
    }

    .material-item-active {
      color: #fff;
      background: #2D71FB;
      .material-item-label {
        color: #fff;
      }
    }
  }

  .right-content {
    width: calc(100% - 142px);
    max-height: 100%;
    overflow: hidden;

    &:hover {
      overflow-x: auto;
    }
  }
}

.input-header {
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;

  .search-icon {
    cursor: pointer;
  }
}

.examine-table-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 15px;
}
/deep/ .el-table::before {
  height: 0;
}
/deep/ .el-table--border::after {
  width: 0;
}
/deep/ .el-table--border {
  border: none;
}

/deep/ .el-table .cell > span {
  font-weight: 500 !important;
  font-family: "Microsoft YaHei", serif !important;
}

/deep/ [class*="leaf"] {
  font-weight: 400 !important;
}
</style>
